<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-6">Logowanie do EDB</h1>
      <label for="login-by-gov.pl" class="label mb-3">
        Jesteś osobą fizyczną?
      </label>
      <v-btn
        rounded
        large
        color="primary"
        id="login-by-gov.pl"
        elevation="0"
        @click="loginWK"
      >
        Zaloguj się poprzez login.gov.pl
      </v-btn>
      <div v-if="!onlyWk">
        <div class="divider my-5"></div>
        <h2 class="label mb-6">
          Jesteś pracownikiem administracji? <br />
          Zaloguj się przez e-mail i hasło.
        </h2>
        <validation-observer ref="observer">
          <form method="post" :action="action">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|email"
              vid="email"
              name="Adres e-mail"
            >
              <v-text-field
                v-model="username"
                name="username"
                label="Adres e-mail"
                placeholder="Adres e-mail"
                outlined
                autofocus
                persistent-placeholder
                :error-messages="errors"
                class="mb-2"
              ></v-text-field>
            </ValidationProvider>
            <v-text-field
              label="Hasło"
              name="password"
              placeholder="Hasło"
              outlined
              persistent-placeholder
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <LoginAlerts
              :show="show"
              :type="color"
              :msg="text"
              @close="show = false"
              dismissible
            />
            <div class="actions">
              <div class="actions_links">
                <LibBtnSimple
                  color="primary"
                  text="Nie pamiętasz hasła?"
                  rounded
                  underline
                  title="Kliknij, aby ustawić nowe hasło do konta użytkownika Elektronicznego Dziennika Budowy"
                  :to="{ name: 'RemindPassword' }"
                />

                <LibBtnSimple
                  color="primary"
                  underline
                  rounded
                  text="Utwórz nowe konto"
                  title="Kliknij, aby utworzyć nowe konto użytkownika Elektronicznego Dziennika Budowy"
                  :to="{ name: 'Register' }"
                />
              </div>
              <v-btn
                type="submit"
                title="Kliknij, aby zalogować się do Elektronicznego Dziennika Budowy"
                rounded
                large
                color="primary"
                elevation="0"
                class="ml-2"
              >
                Zaloguj się
              </v-btn>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
    <dialog-yes-no :dialog="exitiedDialog" />
    <form id="wk" ref="wk" method="post" :action="action">
      <input hidden :value="wkt" name="username" />
    </form>
  </div>
</template>
<script>
import DialogYesNo from "@/components/DialogYesNo.vue";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import LoginAlerts from "../components/LoginAlerts.vue";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

setInteractionMode("lazy");
extend("required", required);
extend("email", email);

const errorsMsg = {
  "bad-credentials": `Wystąpił błąd logowania związany z&nbsp;niepoprawnym adresem e-mail lub błędnym hasłem. Sprawdź poprawność danych do logowania lub skontaktuj się z&nbsp;administratorem.`,
  locked: "Twoje konto jest zablokowane. Skontaktuj się z&nbsp;administratorem."
};

export default {
  name: "Login",
  components: {
    LoginAlerts,
    DialogYesNo,
    LibBtnSimple,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      action: process.env.VUE_APP_AUTH_REST_URL + "/login",
      timeout: 10000,
      text: "Niepoprawne dane logowania",
      color: "error",
      show: false,
      username: "",
      forgotPasswordDisabled: false,
      wkt: null,
      wktSessionId: null,
      exitiedDialog: {
        show: false,
        title: "Hasło",
        text: "Ważność Twojego hasła do konta wygasła. Chcesz zmienić hasło?",
        callback: () => {
          this.$router.push({ name: "ChangingExpiredPassword" });
        }
      },
      onlyWk: false,
      showPassword: false
    };
  },
  props: {
    error: {
      type: String,
      default: undefined
    },
    msg: {
      type: String,
      default: undefined
    }
  },
  metaInfo: {
    title: "Logowanie do EDB"
  },
  methods: {
    loginWK() {
      window.location = process.env.VUE_APP_WK_INIT_URL;
    },
    resetSnack() {
      // setTimeout(() => {
      //   this.show = false;
      // }, this.timeout + 1);
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
  },
  mounted() {
    if (this.$route.query.wk) document.getElementById("wk").submit();

    if (this.msg) {
      this.text = decodeURIComponent(this.msg);
      this.color = "info";
      this.show = true;
      // this.resetSnack();
    }

    if (this.$route.query.error === "expired") {
      this.exitiedDialog.show = true;
    } else if (this.$route.query.error === null || this.$route.query.error) {
      this.text =
        errorsMsg[this.error] ||
        "Wystąpił błąd logowania. Sprawdź poprawność użytej metody logowania (wskazówka: być może powinieneś skorzystać z&nbsp;logowania za pośrednictwem Węzła Krajowego)";
      this.color = "error";
      this.show = true;
      // this.resetSnack();
      // this.$router.replace({'query': null});
    }
    if (this.$route.query.expired) this.exitiedDialog.show = true;

    this.wktSessionId = this.makeid(5);
  },
  created() {
    if (this.$route.query.wk) {
      this.wkt = this.$route.query.wk;
    }
    this.onlyWk =
      this.$route.query.onlyWk && this.$route.query.onlyWk === "true";
  }
};
</script>

<style lang="scss">
a {
  white-space: preserve nowrap;
}
</style>
